import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=d28fa76a"
import script from "./fuwu.vue?vue&type=script&lang=js"
export * from "./fuwu.vue?vue&type=script&lang=js"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=d28fa76a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports